exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_myLinks_PaCCrvvlcaEPhdRpgnq9S {\n  width: 100%;\n  float: left;\n  position: relative;\n  clear: both;\n}\n\n.IA_myLinksContainer_kBQmTFLsjKrlJ04iQ7YZj {\n  clear: both;\n  width: 100%;\n  height: auto;\n  margin-top: 10px;\n  float: left;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_myLinks": "IA_myLinks_PaCCrvvlcaEPhdRpgnq9S",
	"IA_myLinksContainer": "IA_myLinksContainer_kBQmTFLsjKrlJ04iQ7YZj"
};